import { openOptOut } from '../../components/opt-out/open';
import { preventSpamCallsShared } from '../../js/utils';
import { AnalyticsStore } from '../AnalyticsStore';
import { MraidStore } from '../MraidStore';

interface UserOptoutHandlerProps {
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;
  formatOptions: FormatOptions;
}
export class UserOptoutHandler {
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;
  formatOptions: FormatOptions;

  constructor({
    analyticsStore,
    mraidStore,
    formatOptions
  }: UserOptoutHandlerProps) {
    this.analyticsStore = analyticsStore;
    this.mraidStore = mraidStore;
    this.formatOptions = formatOptions;
    this.handle = preventSpamCallsShared(this.handle.bind(this));
  }

  handle(e: React.MouseEvent | React.TouchEvent) {
    e.stopPropagation();
    this.analyticsStore.sendCreativeTrack('optout');
    openOptOut(this.formatOptions);
  }

  handleMraid(e: React.MouseEvent | React.TouchEvent) {
    e.stopPropagation();
    this.analyticsStore.sendCreativeTrack('optout');
    openOptOut(this.formatOptions);
  }
}
